<template>
  <div
    class="widget-circle-button"
    :class="[
      `widget-circle-button--color-${color}`,
      {
        'widget-circle-button--disabled': isDisabled || isLoading,
      },
    ]"
    @click="$emit('click', $event)"
  >
    <widget-spinner
      v-if="isLoading"
      size="36px"
      :color="color"
    />
    <slot v-else />
  </div>
</template>

<script lang="ts" setup>
import WidgetSpinner from '@widgets/shared/components/WidgetSpinner.vue'

const { color, isDisabled, isLoading } = defineProps<{
  color: 'green' | 'red'
  isDisabled: boolean
  isLoading: boolean
}>()

defineEmits<{
  (e: 'click', event: MouseEvent): void
}>()
</script>

<style lang="scss" scoped>
@import '@/styles/custom-variables.scss';

.widget-circle-button {
  width: 76px;
  height: 76px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  line-height: 0;
  border: 2px solid;
  border-radius: 50%;
  cursor: pointer;
  transition: all $transition-200ms-ease-in-out;

  &--color-green {
    background-color: $green50;
    border-color: $green;
    color: $green;

    &:hover,
    &:active {
      background-color: $green100;
    }
  }

  &--color-red {
    background-color: $red50;
    border-color: $red;
    color: $red;

    &:hover,
    &:active {
      background-color: $red100;
    }
  }

  &--disabled {
    opacity: 0.5;
    pointer-events: none;
  }
}
</style>
